export class MeasurementUnit {
    id: number;
    description: string;
    descriptionFr: string;
    status: string
}